import service from '@/utils/fetchPhp'

// 默认返回类型
interface ResponseJson<T> {
  errcode: number
  data: T
  msg: string
}

interface ResponsePromise<T> extends Promise<ResponseJson<T>> {}

// 接口
type ServiceInstance<T = any> = ( params?: any ) => ResponsePromise<T>

const createGet = (api: string, ...arg: any[]) => service.get(api, ...arg).then((res: any) => {
  return res.data
})

const createPost = (api: string, ...arg: any[]) => service.post(api, ...arg).then((res: any) => {
  return res.data
})

const url = BASE_API.PHP

// 客户列表
export interface CustomerListD {
  total_count: string
  data: CustomerD[]
}
export interface CustomerD {
  id: string
  mobile: string
  name: string
  record_url: string
  call_time: string
}

export const customerListA: ServiceInstance<CustomerListD> =
  params => createGet(`${url}/data/list`, { params })

export interface PlanD {
  id: number
  type: string
}
export const getPlanA: ServiceInstance<PlanD> = () => createGet(`${url}/data/get-plan`)

// 任务
export interface HuashuD {
  id: number | string
  title: string
  levels: LevelD[]
}
// 等级
export interface LevelD {
  id: number
  levelname: string
  score_min: string
  score_max: string
}
export const getHuashuA: ServiceInstance<HuashuD[]> = () => createGet(`${url}/data/get-huashu`)

// 详情
export interface DetailD {
  mobile: string
  dial_time: string
  audio_url: string
  grade_name: string
  record_slice: RecordD[]
}
export interface RecordD {
  id: number
  callId: number
  type: string
  content: string
  logicId?: number
  matchType?: boolean
  matchReason?: string
  offset?: string
  duration?: string
  playing?: boolean
}
export const getDetailA: ServiceInstance<DetailD> = params => createGet(`${url}/data/detail`, { params })



